import { render, staticRenderFns } from "./jurisdictionForm_back.vue?vue&type=template&id=5018c80e&"
import script from "./jurisdictionForm_back.vue?vue&type=script&lang=js&"
export * from "./jurisdictionForm_back.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionForm_back.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports